<template>
  <!-- Routes the active OnBoardingPage in the page stack to the appropriate
       component. Used by both the modal (OnBoarding.vue) and the standalone
       /login page (LoginApp.vue) so the two share one design language and
       one source of behaviour. -->
  <div>
    <OnBoardingLoginPage v-if="topPageIsLogin" />
    <OnBoardingSignUpPage v-if="topPageIsSignUp" />
    <OnBoardingDownloadGPXPage v-if="topPageIsDownloadGPX" />
    <OnBoardingConfirmDetailsPage v-if="topPageIsConfirmDetails" />
    <OnBoardingEmailSignUpDetailsPage v-if="topPageIsEmailSignUp" />
    <OnBoardingVerifyEmailPage v-if="topPageIsVerifyEmailSent" />
    <OnBoardingEmailLoginPage v-if="topPageIsEmailLogin" />
    <OnBoardingMagicLinkPage v-if="topPageIsMagicLink" />
    <OnBoardingSuccessPage v-if="topPageIsSuccess" />
    <OnBoardingAddToListPage v-if="topPageIsAddTrailToList" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { OnBoardingPage } from '../../../utils/models/OnBoardingPage';
import OnBoardingAddToListPage from './OnBoardingAddToListPage.vue';
import OnBoardingConfirmDetailsPage from './OnBoardingConfirmDetailsPage.vue';
import OnBoardingDownloadGPXPage from './OnBoardingDownloadGPXPage.vue';
import OnBoardingEmailLoginPage from './OnBoardingEmailLoginPage.vue';
import OnBoardingEmailSignUpDetailsPage from './OnBoardingEmailSignUpDetailsPage.vue';
import OnBoardingVerifyEmailPage from './OnBoardingVerifyEmailPage.vue';
import OnBoardingLoginPage from './OnBoardingLoginPage.vue';
import OnBoardingMagicLinkPage from './OnBoardingMagicLinkPage.vue';
import OnBoardingSignUpPage from './OnBoardingSignUpPage.vue';
import OnBoardingSuccessPage from './OnBoardingSuccessPage.vue';

export default defineComponent({
  name: 'OnBoardingPageRouter',
  components: {
    OnBoardingLoginPage,
    OnBoardingSignUpPage,
    OnBoardingDownloadGPXPage,
    OnBoardingConfirmDetailsPage,
    OnBoardingEmailSignUpDetailsPage,
    OnBoardingVerifyEmailPage,
    OnBoardingEmailLoginPage,
    OnBoardingMagicLinkPage,
    OnBoardingSuccessPage,
    OnBoardingAddToListPage,
  },
  computed: {
    topPage() {
      return this.$store.getters['onBoarding/lastPage'];
    },
    topPageIsAddTrailToList(): boolean {
      return this.topPage === OnBoardingPage.AddTrailToList;
    },
    topPageIsSuccess(): boolean {
      return this.topPage === OnBoardingPage.Success;
    },
    topPageIsEmailSignUp(): boolean {
      return this.topPage === OnBoardingPage.EmailSignUp;
    },
    topPageIsVerifyEmailSent(): boolean {
      return this.topPage === OnBoardingPage.VerifyEmailSent;
    },
    topPageIsEmailLogin(): boolean {
      return this.topPage === OnBoardingPage.EmailLogin;
    },
    topPageIsMagicLink(): boolean {
      return this.topPage === OnBoardingPage.MagicLink;
    },
    topPageIsLogin(): boolean {
      return this.topPage === OnBoardingPage.LoginOptions;
    },
    topPageIsSignUp(): boolean {
      return this.topPage === OnBoardingPage.SignUpOptions;
    },
    topPageIsDownloadGPX(): boolean {
      return this.topPage === OnBoardingPage.DownloadGPX;
    },
    topPageIsConfirmDetails(): boolean {
      return this.topPage === OnBoardingPage.ConfirmDetails;
    },
  },
});
</script>
